import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HashRouter, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import BreadNav from '../components/BreadNav';
import Finder from '../components/Finder';
import LabelSearch from '../components/LabelSearch';
import { getQuoteUrl } from '../components/Selectors';
import { context } from '../utils';

function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}


export const Workflow = () => <HashRouter>
    <ScrollToTop />
    <Routes>
        <Route path="/" element={<ModeChooser />} />
        <Route path="manual" element={<ManualMode />} />
        <Route path="label" element={<LabelMode />} />
    </Routes>
</HashRouter>;


const SelectCard = ({ title, img, description, onClick }) => {
    return <div className="select-card" onClick={onClick}>
        <div className="select-card-title">{title}</div>
        <div className="select-card-icon-container">
            <img src={`${context.static_url}${img}`} className="img-responsive" style={{ height: "100px" }} />
        </div>

        <p className="select-card-description">{description}</p>
    </div>;
};

const ModeChooser = ({ onChange }) => {
    const { t } = useTranslation();

    let navigate = useNavigate();


    const triggerIdentification = () => {
        window.location = context.urls.identification + "?from=workflow";
    };

    const triggerManual = () => {
        navigate('/manual');
    };

    const triggerLabel = () => {
        navigate('/label');
    };

    return <div>
        <BreadNav title={t('Start an Implant Restoration Case')} />
        <section className="workflow-content">
            <div className="workflow-questions"><h1>{t("What information do you have?")}</h1>

                <div className="container">
                    <div className="row" style={{ "justifyContent": "center" }}>
                        <div className="col-md-4 select-card-col">
                            <SelectCard title={t("An Unknown Radiograph")} description={t("The implant is not known and needs to be identified.")} img={"img/sample_xray.png"} onClick={triggerIdentification} />
                        </div>
                        {context.is_staff || true ?
                            <div className="col-md-4 select-card-col">
                                <SelectCard title={t('An implant label')} description={t('You have a picture of the label, and look for compatible components.')} img={"img/sample_label.png"} onClick={triggerLabel} />
                            </div> : ''}

                        <div className="col-md-4 select-card-col">
                            <SelectCard title={t('A reference or model name')} description={t('Enter the brand, model or reference manually to find compatible components.')} img={"img/manual_input.png"} onClick={triggerManual} />
                        </div>

                    </div>


                </div>
            </div>
        </section >
    </div >;
};

export const LabelMode = () => {
    const { t } = useTranslation();
    const [model, setModel] = useState(null);
    const onModelChange = val => {
        setModel(val);
        if (!val) {
            return;
        }
        const redirectUrl = val.components_url || getQuoteUrl(val);
        window.location.href = redirectUrl;
    };
    return (
        <div>
            <BreadNav title={t("Submit implant label picture")} backTo={"/"} />
            <div className="workflow-content">

                <LabelSearch onChange={onModelChange} />


            </div>
        </div>
    );
};


export const ManualMode = () => {
    const { t } = useTranslation();
    return (
        <div>
            <BreadNav title={t("Enter Reference Manually")} backTo={"/"}>
            </BreadNav>
            <div className="workflow-content">
                <h1>{t("Specify for which implant model you are looking for components:")}</h1>
                <Finder />
            </div>
        </div>
    );
};

export default Workflow;
